import { render, staticRenderFns } from "./ChoreCalendarDetail.vue?vue&type=template&id=2d4d4026&scoped=true"
import script from "./ChoreCalendarDetail.vue?vue&type=script&lang=js"
export * from "./ChoreCalendarDetail.vue?vue&type=script&lang=js"
import style0 from "./ChoreCalendarDetail.vue?vue&type=style&index=0&id=2d4d4026&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4d4026",
  null
  
)

export default component.exports